import { Button, ButtonGroup, For, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { Checkbox } from '@components/ui/checkbox/Checkbox';
import { ChangeEvent, ElementType } from 'react';
import { FormattedMessage, PrimitiveType } from 'react-intl';

export interface CheckboxFilterItem {
  label: string;
  labelValues?: Record<string, PrimitiveType>;
  checked?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  icon?: ElementType;
  iconColor?: string;
  count?: number;
  comment?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

interface CheckboxListAction {
  disabled: boolean;
  onClick: () => void;
}

interface CheckboxListFilterProps {
  items: CheckboxFilterItem[];
  gap?: number;
  actionAll?: CheckboxListAction;
  actionNone?: CheckboxListAction;
}

export function CheckboxListFilter({ items, gap = 2, actionAll, actionNone }: Readonly<CheckboxListFilterProps>) {
  return (
    <VStack boxSize="100%" alignItems="start" gap={gap}>
      {(actionAll || actionNone) && (
        <ButtonGroup gap={1}>
          {actionAll && (
            <Button variant="toggle" size="toggleS" disabled={actionAll.disabled} onClick={actionAll.onClick}>
              <FormattedMessage id="global.all" />
            </Button>
          )}
          {actionNone && (
            <Button variant="toggle" size="toggleS" disabled={actionNone.disabled} onClick={actionNone.onClick}>
              <FormattedMessage id="global.none" />
            </Button>
          )}
        </ButtonGroup>
      )}

      <For each={items}>
        {({ checked, label, onChange, labelValues, readOnly, disabled, icon, iconColor, count, comment }) => (
          <Checkbox
            checked={checked}
            key={label}
            value={label}
            readOnly={readOnly}
            disabled={disabled}
            label={
              <HStack gap={1}>
                {icon && <Icon as={icon} boxSize="16px" color={iconColor} />}
                <VStack gap={0} alignItems="start">
                  <Text>
                    <FormattedMessage id={label} values={labelValues} />
                  </Text>
                  {comment && (
                    <Text color="neutral.300">
                      <FormattedMessage id={comment} />
                    </Text>
                  )}
                </VStack>
                {count !== undefined && (
                  <Text marginLeft="auto" fontWeight="medium" color="skyBlue">
                    {count}
                  </Text>
                )}
              </HStack>
            }
            onChange={(event) => !readOnly && onChange?.(event)}
          />
        )}
      </For>
    </VStack>
  );
}
